import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'
import 'firebase/messaging'
import config from '@/Agent/config'

// Initialize Firebase
firebase.initializeApp(config.firebaseConfig)

// Firebase Auth
const auth = firebase.auth()
const googleProvider = new firebase.auth.GoogleAuthProvider()
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider()
const appleAuthProvider = new firebase.auth.OAuthProvider('apple.com')

// Firebase Analytics
const analytics = firebase.analytics()

// Firebase Messaging
const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null

export {
  auth,
  googleProvider,
  facebookAuthProvider,
  appleAuthProvider,
  analytics,
  messaging,
}



// WEBPACK FOOTER //
// src/Firebase.js